module.exports = __webpack_public_path__ + "img/share_twitter.94c16535.svg";